/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-05 00:00:00
 *
 *******************************************************/
// @flow

import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import externalIcon from 'src/assets/images/common/external-small_minor.svg';

const Hyperlink = props => {
  const { url, onClick, text, isNoIcon } = props;

  if (url) {
    return (
      <a className="hyperlink" target="_blank" href={url} rel="noopener noreferrer">
        {text}
        {!isNoIcon && <img src={externalIcon} width={20} height={20} alt="icon" />}
      </a>
    );
  }

  return (
    <span className="hyperlink" onClick={onClick}>
      {text}
      {!isNoIcon && <img src={externalIcon} width={20} height={20} alt="icon" />}
    </span>
  );
};

export default withI18n()(Hyperlink);
